import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CpakDatePipe } from './date.pipe';

@NgModule({
  declarations: [CpakDatePipe],
  exports: [CpakDatePipe],
  providers: [DatePipe, CpakDatePipe],

  imports: [CommonModule],
})
export class DatePipeModule {}
